import i18n from 'i18n';
import { type PurchasePathState } from 'individual/types/initialState';
import { getInitialState } from 'utils';

const PurchasePageIngress = () => {
  const { marketableProduct } = getInitialState() as PurchasePathState;
  const ingressText =
    marketableProduct.coverages.filter(
      (coverage) => coverage.mandatory || coverage.preSelected
    ).length > 1
      ? i18n.t('purchaseView.ingressPlural')
      : i18n.t('purchaseView.ingressSingular');
  return <p>{ingressText}</p>;
};

export default PurchasePageIngress;
